

import React from 'react';

import RingLoader from "react-spinners/RingLoader";

import ClipLoader from "react-spinners/ClipLoader";

export { RingLoader, ClipLoader };